import { useAppDispatch } from 'app/hooks'
import { logout } from 'app/reducer/authSlice'
import { getClassesAction } from 'app/reducer/assessmentSlice'
import ActionButton from 'components/ActionButton'
import { useNavigate } from 'react-router-dom'
import { useContext, useEffect } from 'react'
import { QuestionnaireContext } from 'components/Assessment/QuestionnaireContext'
import {
  ModalActions,
  ModalCard,
  ModalMessage,
  ModalOverlay,
  ModalTitle
} from 'components/modals/styles'
import styled from 'styled-components'

const Overlay = styled(ModalOverlay)`
  z-index: 220;
`

const Card = styled(ModalCard)`
  width: 500px;
  max-width: 500px;
`

const Header = styled.div`
  margin-bottom: 12px;
`

const Body = styled.div`
  margin-bottom: 16px;
`

const Footer = styled(ModalActions)`
  margin-top: 0;
`

const AssesmentScoreModal = () => {
  const { assessmentScore, setAssessmentScore, questions } =
    useContext(QuestionnaireContext)

  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const answeredQuestions = ((assessmentScore || 0) * questions.length) / 100
  const totalQuestions = questions.length
  const shouldShowModal = Number.isFinite(assessmentScore)

  const logoutStudent = () => {
    setAssessmentScore(null!)
    dispatch(logout())
    navigate('/')
  }

  const selectAnotherAssessment = async () => {
    /**
     * Refresh the available classrooms before returning so the
     * assessment picker reopens with the latest apo26 data.
     */
    setAssessmentScore(null!)
    await dispatch(getClassesAction())
    navigate('/classroom')
  }

  useEffect(() => {
    return () => {
      localStorage.removeItem('assesmentScore')
    }
  }, [])

  if (!shouldShowModal) return null

  return (
    <Overlay>
      <Card
        role='dialog'
        aria-modal='true'
        aria-labelledby='assessment-score-modal-title'
      >
        <Header>
          <ModalTitle id='assessment-score-modal-title'>
            Assessment Score: {assessmentScore}%
          </ModalTitle>
        </Header>
        <Body>
          <ModalMessage>
            Your assessment has been submitted. You answered{' '}
            <strong>
              {answeredQuestions} out of {totalQuestions}
            </strong>{' '}
            questions correctly.
          </ModalMessage>
        </Body>
        <Footer>
          <ActionButton
            label='Log Out'
            variant='error'
            width={98}
            onClick={logoutStudent}
          />
          <ActionButton
            label='Select Another Assessment'
            variant='success'
            width={230}
            onClick={selectAnotherAssessment}
          />
        </Footer>
      </Card>
    </Overlay>
  )
}

export default AssesmentScoreModal
